"use strict";

var isProperFormat = require('./isProperFormat');
/**
 * Returns a price table based off the name and version.
 *
 * @memberof! Pricing
 * @param {string} price_table Name of the price table to retrieve.
 * @param {number} version Version of the price table to retrieve.
 * @return {json} Price table with proper name + version.
 * @throws {Error} When name is the empty string.
 * @throws {Error} When version is less than 0.
 * @throws {Error} When either input is null or undefined.
 * @throws {Error} When price table doesn't exist at all.
 * @throws {Error} When the name + version can't be found.
 * @throws {Error} When the price table isn't properly formatted.
 */


function getPriceTable(name, version, priceTables) {
  // Validate parameters
  if (name === '') {
    throw new Error('price_table cannot be an empty string.');
  }

  if (name == null || version == null) {
    debugger;
    throw new Error("Input cannot be undefined. Got\n\nname:".concat(name, ",\n\nversion:").concat(version, ".\n\n"));
  }

  if (version < 0) {
    throw new Error('Version cannot be less than 0.');
  }

  if (!priceTables[name]) {
    throw new Error("".concat(name, " cannot be found."));
  }

  var table = priceTables[name];

  if (!isProperFormat(table)) {
    console.error(table);
    throw new Error("".concat(name, " is improperly formatted, doesn't follow v{version} convention."));
  }

  if (table["v".concat(version)]) {
    return table["v".concat(version)];
  }

  throw new Error("".concat(name, " has no version ").concat(version, "."));
}

module.exports = getPriceTable;